import { useReactiveVar } from '@apollo/client';
import React from 'react';

import useReportStatistics from '../../../../apis/graphql/reports/useReportStatistics';
import { Notification } from '../../../../components/BlueTheme';
import DiagramComponent from '../../../../components/BlueTheme/ChartComponent/DiagramComponent';
import { NotificationType } from '../../../../components/BlueTheme/Notification/types';
import { selectedOrganizationIdVar } from '../../../../constants';
import { StaticFilters } from '../../types/reports';
import { COLOR_SCHEME_REPORTS, TOOLTIP } from './constant';
import { StyledChartsWrapper } from './styled';
import { convertDataForChart } from './utils';

type Props = {
  staticFilters: StaticFilters;
};

const Charts = ({ staticFilters }: Props): JSX.Element => {
  const organizationId = useReactiveVar(selectedOrganizationIdVar) || '';
  const { data, loading, error } = useReportStatistics(organizationId, staticFilters);
  const platformData = convertDataForChart(data?.platform, COLOR_SCHEME_REPORTS);
  const adTypeData = convertDataForChart(data?.adProduct, COLOR_SCHEME_REPORTS);
  const publisherBreakdownData = convertDataForChart(data?.publisherBreakdown, COLOR_SCHEME_REPORTS);

  if (error) {
    return (
      <StyledChartsWrapper data-testid="widgetsWrapperError">
        <Notification type={NotificationType.error} description="Can not get widget data. Please try later." />
      </StyledChartsWrapper>
    );
  }

  return (
    <StyledChartsWrapper data-testid="widgetsWrapper">
      <DiagramComponent
        title="Platform"
        loading={loading}
        tooltip={TOOLTIP}
        data={platformData}
        emptyText="No data in selected date range"
        metricName="Completions"
      />
      <DiagramComponent
        title="Ad Type"
        loading={loading}
        tooltip={TOOLTIP}
        data={adTypeData}
        emptyText="No data in selected date range"
        metricName="Completions"
      />
      <DiagramComponent
        title="Publisher (* DSE Only)"
        loading={loading}
        tooltip={TOOLTIP}
        data={publisherBreakdownData}
        emptyText="No data in selected date range"
      />
    </StyledChartsWrapper>
  );
};

export default Charts;
